<template>
    <ds-card class="content-container">
        <div class="empty-state-card">
            <img
                class="setup-image"
                height="72"
                width="72"
                :src="iconPath"
            />

            <h3 class="header">
                {{ headerText }}
            </h3>

            <div class="body">
                {{ bodyText }}
            </div>

            <DsOutlineButton
                target="_blank"
                as="a"
                :href="linkAddress"
            >
                {{ $t('email.healthWidget.rehabServiceTile.engagement.helpButtonLabel') }}
            </DsOutlineButton>
        </div>
    </ds-card>
</template>

<script>
export default {
    props: {
        iconPath: String,
        headerText: String,
        bodyText: String,
        linkAddress: String,
        helpButtonLabel: String,
    },
};

</script>

<style lang="scss" scoped>
.content-container {
    align-items: center;
}

.header {
    font-size: $font-size-xl;
    font-weight: 700;
    padding: $spacing-200 0;
    line-height: 36px;
}

.body {
    line-height: $line-height-lg;
    padding-bottom: $spacing-200;
}

.empty-state-card {
    padding: $spacing-300;
    margin: $spacing-800 0 $spacing-200;
}

</style>
